export default __webpack_public_path__ + "static/media/dashboard-mac.694c112f.jpeg";